
import React from 'react'
import tes from '../assets/tes.jpeg'
import tes2 from '../assets/tes2.jpg'
import tes3 from '../assets/tes3.jpeg'




export const tests = [
    {
id: 1,
name: 'GATE',
Description:'This trusted evaluation covers language proficiency, academic aptitude, and job-specific skills, boosting your chances for visa approval and showcasing your competence for studying or working abroad.',
price:'12.99',
uploaded_images:[tes]

},
{
    id: 2,
    name:'POCAS',
    Description: 'This trusted evaluation covers language proficiency, academic aptitude, and job-specific skills, boosting your chances for visa approval and showcasing your competence for studying or working abroad.',
    price:'15.99',
    uploaded_images:[tes2]
},
{
id: 3,
name: 'LISA',
Description: 'This trusted evaluation covers language proficiency, academic aptitude, and job-specific skills, boosting your chances for visa approval and showcasing your competence for studying or working abroad.',
price:'9.99',
uploaded_images:[tes3]
},
]